export const CustomerFieldLabels = {
  Name: 'Name',
  BusinessType: 'Business Type',
  BusinessAddress: 'Business Address',
  Location: 'Location',
  MatchState: 'Match State',
  IsBlocked: 'Customer Blocked',
  CreatedAt: 'Created',
  UpdatedAt: 'Updated',
};

export const CustomerFieldColumn = {
  Name: 'name',
  BusinessType: 'businessType',
  BusinessAddress: 'businessAddress',
  Location: 'location',
  IsBlocked: 'isBlocked',
  MatchState: 'matchState',
  CreatedAt: 'createdAt',
  UpdatedAt: 'updatedAt',
};

// Quick-filter values for the match-state pill on the Customer list.
export const MatchStateQuickFilter = {
  QueryKey: 'matchState',
  All: 'all',
  NeedsReview: 'NeedsReview',
};
